'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInfoRowItem = undefined;

var _UserInfoRowItem2 = require('./UserInfoRowItem');

var _UserInfoRowItem3 = _interopRequireDefault(_UserInfoRowItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.UserInfoRowItem = _UserInfoRowItem3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserInfoRowItem/index.js
// module id = 1781
// module chunks = 0